import { Link } from "react-router-dom"

import {hvnUriRoot, shopInfo, linkNavs, areaName } from "../core/defines";
import { NavLinkMaker, telBlockPc } from "../core/core"

function reserveBtn(hvnId){

    let id =""
    let linkTxt = "ネット予約"
    if(hvnId){
        id= `?girl_id=${hvnId}`
        linkTxt= "このキャストを予約"
    }

    return(
        <nav className="btn-fix reserve">
            <a href={`${hvnUriRoot}/A6ShopReservation/${id}`} target="_blank" rel="noopener noreferrer">{linkTxt}</a>
        </nav>
    )
}
function telBtn(tel){

    return(
        <nav className="btn-fix tel">
            <a className="btn-tel" href={"tel:"+ tel }>電話予約</a>
        </nav>
    )
}


function Footer({hvnId=null}){
    return(
        <footer className="txt-center">
            <section>
                <img className="sp" src="https://api.marineblue-g.com/api/topbanner?t=m_marineblue" />

                <p className="sp mt">
                    <a
                        rel="nofollow"
                        href="https://kitakanto.qzin.jp/mitomarineblue/?v=official"
                        target="_blank"
                    >
                        <img
                            src="/img/20250715_recruit.webp"
                            alt="28部屋のお城で即日出稼ぎ勤務・体験入店大歓迎"
                        />
                    </a>
                </p>



                <div className="logo"></div>
                <nav className="pc box">
                    <ul className="navs">
                        {linkNavs.map((el)=>{
                            return(
                                <li key={el.name}>
                                    <NavLinkMaker data={el}>
                                        {el.name}
                                    </NavLinkMaker>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
                <div>
                    {telBlockPc()}
                </div>
                <p className="subtitle">{ areaName }のソープランド 【{ shopInfo.name }】</p>
                <span className="copy">Copyright&copy;{ shopInfo.name } All Rights Reserved.</span>
            </section>
            <div id="btn-fix-parent">
                {telBtn(shopInfo.tel)}
                {reserveBtn(hvnId)}
            </div>
        </footer>
    );
}
export default Footer;